import { Modal } from 'antd';
import { useUnit } from 'effector-react';
import { $infoModal, resetInfoModalEv } from '../../models/zoom7Model/index.js';
import { public_info } from '../../data/public_info.js';

function PublicInfoModal() {
  const infoModal = useUnit($infoModal);
  const resetInfoModal = useUnit(resetInfoModalEv);

  return (
    <Modal open={!!infoModal} centered footer={null} onCancel={resetInfoModal}>
      {infoModal && (
        <>
          <div style={{ fontWeight: 'bold', fontSize: 18 }}>
            {public_info[infoModal].title}
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: public_info[infoModal].desc }}
          />
        </>
      )}
    </Modal>
  );
}

export default PublicInfoModal;
